import type { ReactNode } from 'react';
import { Icon } from '../icons/Icon.js';
import { useAuth } from './auth-context.js';

/** 権限不足の面（ルート単位で使う。サーバの 403 は ErrorState が扱う） */
export function ForbiddenNotice({ message = 'この画面を表示する権限がありません' }: { message?: string }) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center gap-2 px-5 py-16 text-center">
      <Icon name="lock" size={28} className="text-fg-tertiary" />
      <p className="text-headline">{message}</p>
      <p className="text-callout text-fg-secondary">必要な権限が付与されていません。管理者に確認してください。</p>
    </div>
  );
}

/**
 * anyOf の権限のどれかを持つ（または roles のどれかを持つ）ときだけ描く。
 * 権限名が決まっていない画面は roles: ['owner','admin'] で暫定的に守る。
 */
export function PermissionGate({ anyOf = [], roles = [], children, fallback }: { anyOf?: string[]; roles?: string[]; children: ReactNode; fallback?: ReactNode }) {
  const { canAny, me } = useAuth();
  const ok = (anyOf.length > 0 && canAny(...anyOf)) || roles.some((r) => me?.roles.includes(r));
  if (!ok) return <>{fallback ?? <ForbiddenNotice />}</>;
  return <>{children}</>;
}
